import type { Template } from "@/types";

export const PO_04_H0_V4: Template[] = [
    {
        id: "po-04-h0v4-01",
        name: "PO 01 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 37, y: 199, width: 301, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 199, width: 300, height: 431, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 199, width: 300, height: 431, rotation: 0, imageRotation: 0 },
            { id: "4", x: 962, y: 199, width: 300, height: 431, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-02",
        name: "PO 02 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 186, width: 319, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 327, y: 186, width: 319, height: 457, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 186, width: 319, height: 457, rotation: 0, imageRotation: 0 },
            { id: "4", x: 981, y: 186, width: 318, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-03",
        name: "PO 03 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 33, y: 207, width: 288, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 207, width: 288, height: 413, rotation: 0, imageRotation: 0 },
            { id: "3", x: 682, y: 207, width: 288, height: 413, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 207, width: 288, height: 413, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-04",
        name: "PO 04 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 38, y: 167, width: 344, height: 492, rotation: 0, imageRotation: 0 },
            { id: "2", x: 391, y: 253, width: 223, height: 320, rotation: 0, imageRotation: 0 },
            { id: "3", x: 684, y: 253, width: 223, height: 320, rotation: 0, imageRotation: 0 },
            { id: "4", x: 915, y: 167, width: 344, height: 492, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-05",
        name: "PO 05 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 30, y: 136, width: 390, height: 553, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 136, width: 191, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 417, width: 191, height: 272, rotation: 0, imageRotation: 0 },
            { id: "4", x: 781, y: 136, width: 387, height: 553, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-06",
        name: "PO 06 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 39, y: 40, width: 522, height: 749, rotation: 0, imageRotation: 0 },
            { id: "2", x: 569, y: 487, width: 213, height: 302, rotation: 0, imageRotation: 0 },
            { id: "3", x: 790, y: 487, width: 213, height: 302, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1011, y: 487, width: 212, height: 302, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-07",
        name: "PO 07 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 90, y: 78, width: 468, height: 669, rotation: 0, imageRotation: 0 },
            { id: "2", x: 687, y: 171, width: 339, height: 487, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1034, y: 78, width: 229, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1034, y: 418, width: 229, height: 331, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-08",
        name: "PO 08 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 90, y: 78, width: 468, height: 669, rotation: 0, imageRotation: 0 },
            { id: "2", x: 686, y: 78, width: 229, height: 332, rotation: 0, imageRotation: 0 },
            { id: "3", x: 686, y: 417, width: 229, height: 331, rotation: 0, imageRotation: 0 },
            { id: "4", x: 923, y: 171, width: 339, height: 487, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-09",
        name: "PO 09 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 77, width: 470, height: 674, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 534, y: 77, width: 231, height: 333, rotation: 0, imageRotation: 0 },
            { id: "3", x: 534, y: 418, width: 231, height: 333, rotation: 0, imageRotation: 0 },
            { id: "4", x: 773, y: 77, width: 470, height: 674, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h0v4-10",
        name: "PO 10 - H0V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h0_v4_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 77, width: 470, height: 674, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 77, width: 470, height: 674, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1012, y: 77, width: 231, height: 333, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1012, y: 418, width: 231, height: 333, rotation: 0, imageRotation: 0 }
        ],
    }
];